var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#881818",
    d: "M7 9.98a.9.9 0 0 1-.312-.053.7.7 0 0 1-.27-.177l-3-3a.76.76 0 0 1-.24-.583.85.85 0 0 1 .833-.844.78.78 0 0 1 .594.24l1.562 1.562V1.167q0-.354.24-.594T7 .333t.593.24.24.594v5.958l1.562-1.562a.78.78 0 0 1 .594-.24.85.85 0 0 1 .834.844.76.76 0 0 1-.24.583l-3 3a.7.7 0 0 1-.27.177A.9.9 0 0 1 7 9.98m-5 3.687q-.687 0-1.176-.49A1.6 1.6 0 0 1 .334 12v-1.666q0-.355.24-.594.24-.24.593-.24.354 0 .594.24t.24.594V12h10v-1.666q0-.355.24-.594.239-.24.593-.24t.594.24q.24.24.24.594V12q0 .688-.49 1.177t-1.177.49z"
  })));
};
export default SvgDownload;